import { sendEvent } from "@app/utils/tracking/Tracker";

import { UserEventGroupPatch } from "../types/eventGroupTypes";

/*
  Calendar Sharing events
*/

export const openShareDialog = sendEvent<{ eventId: string }>(
  "calendar_sharing_open_share_dialog"
);

export const changeDistribution = sendEvent<
  UserEventGroupPatch & { eventId: string }
>("calendar_sharing_change_distribution");

export const addEntities = sendEvent<{ eventId: string; numEntities: number }>(
  "calendar_sharing_add_entities"
);
